import React, { useState } from "react";
import { Link } from "react-router-dom";
import SubSpecialitiesInfo from "../../data/SubSpecialitiesInfo"; // adjust path if needed
import proceduresData from "../../data/proceduresData"; 

const tabContent = {
  Subspecialties: SubSpecialitiesInfo
    .filter((item) => item.category === "Subspecialties")
    .map((item) => ({
      name: item.title,
      icon: item.icon,
      slug: item.slug,
    })),
  tests: proceduresData
    .filter((item) => item.category === "tests")
    .map((item) => ({
      name: item.title,
      icon: item.icon,
      slug: item.slug,
    })),
};

const ServicesList = () => {
  const [activeTab, setActiveTab] = useState("Subspecialties");
  const [isExpanded, setIsExpanded] = useState(false);

  // Apply slicing to limit items shown initially (5 for Subspecialties/Procedures)
  const itemsToShow = tabContent[activeTab].slice(
    0,
    isExpanded ? undefined : 5
  );

  // Toggle function for expanding/collapsing items
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const pathSegment = activeTab === "tests" ? "tests" : "subspecialities";

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 text-center">
      {/* Tabs */}
      <div className="flex flex-col sm:flex-row sm:justify-center sm:space-x-4 lg:space-x-24 border-b border-[#d78558] mb-6 sm:mb-10">
        {Object.keys(tabContent).map((tab) => (
          <button
           aria-label="Tab"
            key={tab}
            onClick={() => {
              setActiveTab(tab);
              setIsExpanded(false);
            }}
            className={`py-2 sm:pb-2 text-base sm:text-lg font-roboto font-semibold uppercase tracking-wide ${
              activeTab === tab
                ? "text-[#d78558] border-b-4 border-[#d78558]"
                : "text-white hover:text-[#fd6b6b]"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Based on Tab */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-8 lg:gap-10 mb-6 sm:mb-10">
        {itemsToShow.map((item) => (
          <Link
            to={`/services/${pathSegment}/${item.slug}`}
            aria-label={`/services/${pathSegment}/${item.slug}`}
            key={item.name}
            className="flex flex-col items-center hover:scale-105 transition-transform"
          >
            <div className="text-4xl sm:text-5xl mb-2">
              <img
                src={item.icon}
                alt={item.name}
                className="w-full h-16 sm:h-20 object-contain"
              />
            </div>
            <div className="text-xs sm:text-sm font-bold text-[#d78558] uppercase text-center">
              {item.name}
            </div>
          </Link>
        ))}
      </div>
      {tabContent[activeTab].length > 5 && (
        <p
          className="text-white text-base sm:text-lg underline cursor-pointer hover:text-[#fd6b6b] pt-8 sm:pt-16 pb-0 lg:pb-40"
          onClick={toggleExpand}
        >
          {isExpanded
            ? "View less"
            : `View all about our Radiology ${activeTab}`}{" "}
          &gt;
        </p>
      )}
    </div>
  );
};

export default ServicesList;